var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("| Versión "+_vm._s(_vm.appVersion)+" - \n    "),(_vm.errorConexion)?_c('span',{staticStyle:{"color":"#ff3636"}},[_vm._v("Error conectando al webservice de PalJetERP")]):_c('span',[_vm._v(_vm._s(_vm.paljetWsVersion))])])}
var staticRenderFns = []

export { render, staticRenderFns }